import { setSpecificMessage, everyItem } from "valibot";
setSpecificMessage(
  everyItem,
  (issue) => `Élément invalide: reçu ${issue.received}`,
  "fr"
);